import { apiCall } from "../../utils/servicesUtils"

const BASE_URL = process.env.REACT_APP_BACKEND_URL

export const apiPostUploadVideo = (
    video: File,
    projectId: string,
    threadId: string
): Promise<IVideo> => {
    const urlFetch = `${BASE_URL}/api/v2/upload-video`
    const formData = new FormData()
    formData.append('video', video)
    formData.append('project_id', projectId)
    formData.append('thread_id', threadId)

    return apiCall(
        urlFetch,
        'POST',
        formData,
        true
    )
}

export const apiGetVideoABCDSAssessment = (
    projectId: string,
    threadId: string,
    videoId: string
): Promise<FeatureAnalysisReport> => {
    const urlFetch = `${BASE_URL}/api/projects/${projectId}/threads/${threadId}/videos/${videoId}/quality-score`
    return apiCall(urlFetch, 'GET', null)
}

export const apiPostVideoABCDSAssessment = (
    projectId: string,
    threadId: string,
    videoId: string
): Promise<FeatureAnalysisReport> => {
    const urlFetch = `${BASE_URL}/api/projects/${projectId}/threads/${threadId}/videos/${videoId}/quality-score`
    return apiCall(urlFetch, 'POST', null)
}
